var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-navigator-iframe-page",attrs:{"path":_vm.path}},[_c('iframe',{attrs:{"frameborder":"0","src":_vm.p_src}})])}
var staticRenderFns = []

export { render, staticRenderFns }